export interface QuestionItemType {
  question: string
  icon: string
  alt: string
  answer: string
}

export const QUESTIONS: QuestionItemType[] = [
  {
    question: 'Who are the brains behind The Playground?',
    answer:
      'This tech-powered workspace was developed and updated based on what you need. Plus, some very smart AI. We asked for feedback and made sure your concerns were heard and accounted for. We’ll keep asking, and we’ll keep improving.',
    icon: require('assets/icons/brain-playground-gif.gif'),
    alt: 'Brain Playground',
  },
  {
    question: 'How does The Playground help me with my tasks, projects and team collaboration?',
    answer:
      'By transforming and digitizing our processes and helping you work faster, easier and smarter than ever. The Playground gives you full transparency of the work being done anywhere in the world. It helps accelerate time to market, introduces agility, scales reporting, and serves as a "learning bank" where we capture, codify and scale learnings - both on consumers and our business.',
    icon: require('assets/icons/slide-playground-gif.gif'),
    alt: 'Slide Playground',
  },
  {
    question: 'Who is working in The Playground?',
    answer:
      'The Playground is built for all OUs and global Marketing and Innovation teams, our external partners, agencies, and bottlers. From planning, to ideation, task and project management, team building and assignments, it’s your day-to-day tech-powered workspace to create, collaborate and grow.',
    icon: require('assets/icons/user-playground-gif.gif'),
    alt: 'User Playground',
  },
  {
    question: 'If the national animal of Scotland is the unicorn, do we have one for The Playground?',
    answer:
      'Wow, that’s amazing and a little weird at the same time. We don’t have one at the moment, but hey, pretty much anything’s possible in The Playground. ',
    icon: require('assets/icons/unicorn-playground-gif.gif'),
    alt: 'Unicorn Playground',
  },
  {
    question: 'What is Intercom and how do I use it?',
    answer:
      'Intercom is our AI-powered chat for support, easy to use, easy to find. It’s the red button on the lower right of The Playground, patiently waiting for you. So, ask away. It knows quite a lot. Ok, maybe not what you had for lunch.',
    icon: require('assets/icons/intercom-question-playground-gif.gif'),
    alt: 'Intercom Playground',
  },
  {
    question: 'What do I do if I need support or help with anything in The Playground?',
    answer:
      'Intercom, Intercom, Intercom. Pop in your question along with your contact name, email address, KO ID and request details.',
    icon: require('assets/icons/support-imac-playground-gif.gif'),
    alt: 'Support Playground',
  },
]
